// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"895":"download","907":"announcement"}[chunkId] + "." + {"895":"e9a61a38","907":"3a6a90ea"}[chunkId] + ".js";
};